import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { BONUSES } from '../../data/collection';
export function BonusSection() {
  return <section id="bonos" aria-labelledby="bonos-title" className="w-full bg-blush" data-id="element-182" data-mp="38q08kqeia3u2">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 lg:py-24" data-id="element-183" data-mp="2tspuraee4lv6">
        <SectionHeading id="bonos-title" title="Y además, recibís estos 5 bonos de regalo" intro="Incluidos con tu colección, sin costo adicional." data-id="element-184" data-mp="2yppsmy136ib7" />

        <ul className="mt-10 grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-5 [&>*]:min-w-0" data-id="element-185" data-mp="3rfpzv3j287h8">
          {BONUSES.map(bonus => <li key={bonus.number} className="flex" data-id="element-186" data-mp="3co7o5hx8gz3o">
              <article className="flex w-full min-w-0 flex-col" data-id="element-187" data-mp="3holki2ph2klv">
                <img src={bonus.cover.src} alt={bonus.cover.alt} width={bonus.cover.width} height={bonus.cover.height} loading="lazy" decoding="async" className="block aspect-square w-full rounded-[12px] object-contain" data-id="element-188" data-mp="99k0r20h5cwo" />
                <p className="mt-3 text-[0.85rem] font-bold text-coral-ink" data-id="element-189" data-mp="332rcbab2w47r">Bono {bonus.number}</p>
                <h3 className="mt-1 break-words font-serif text-[1.02rem] font-semibold leading-[1.25] text-graphite sm:text-[1.12rem]" data-id="element-190" data-mp="3hrnfasya2r1i">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[0.95rem] leading-relaxed text-graphite-soft" data-id="element-191" data-mp="3qphdyajilwru">{bonus.benefit}</p>
                <p className="mt-auto flex flex-wrap items-center gap-x-2 gap-y-1 pt-3" data-id="element-192" data-mp="3lr5zfmi9yy3a">
                  <span className="text-[0.95rem] font-semibold text-graphite-soft line-through" data-id="element-193" data-mp="4i9chjbpua13">
                    <span className="sr-only" data-id="element-194" data-mp="3vr6m9ifcrwc8">Precio de referencia: </span>
                    {bonus.compareAt}
                  </span>
                  <span className="rounded-full bg-sage-ink px-2.5 py-1 text-[0.8rem] font-extrabold text-white" data-id="element-195" data-mp="26cs3der0n3on">
                    De regalo
                  </span>
                </p>
              </article>
            </li>)}
        </ul>
      </div>
    </section>;
}